// Imports React
import { createBrowserRouter, Navigate } from "react-router-dom";
import { lazy } from "react";

// Imports third-party
import Layout from "../components/layout";
// import About from "./about";

// Lazy load pages
const Home = lazy(() => import("./home"));

/**
 * Route configuration array
 */
const routes = [
  {
    path: "/",
    element: (
      <Layout>
        <Home />
      </Layout>
    ),
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];

/**
 * Route settings to be used by RouterProvider in main.tsx
 */
export const router = createBrowserRouter(routes);
